/* unplugin-vue-components disabled */import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  "class": "content"
};
var _hoisted_2 = {
  "class": "about-right"
};
var _hoisted_3 = {
  "class": "about-item"
};
var _hoisted_4 = {
  "class": "about-item-left"
};
var _hoisted_5 = {
  "class": "item-text"
};
import { enterpriseListApi } from "../../api/work/work";
import { cloneDeep } from 'lodash';
export default /*@__PURE__*/_defineComponent({
  __name: 'PeiXun',
  setup: function setup(__props) {
    var centerpiseData = ref([]);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res, _cloneDeep;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return enterpriseListApi();
          case 2:
            res = _context.sent;
            if (res.code === 200) {
              centerpiseData.value = (_cloneDeep = cloneDeep(res.data)) !== null && _cloneDeep !== void 0 ? _cloneDeep : [];
            } else {
              ElMessage.error(res.msg);
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(centerpiseData), function (item) {
        return _openBlock(), _createBlock(_component_router_link, {
          to: "/",
          key: item.name
        }, {
          "default": _withCtx(function () {
            return [_createTextVNode(_toDisplayString(item.name), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))])])])])])]);
    };
  }
});